import initialiseSingleSelects from "./bookingForm/initialiseSingleSelects";

const initBookingForm = () => {
  initialiseSingleSelects();
  initBookingFormSubmitLoadingState();
};

const initBookingFormSubmitLoadingState = () => {
  const bookingForms = document.querySelectorAll<HTMLFormElement>(
    "form[data-booking-form]"
  );

  bookingForms.forEach((bookingForm) => {
    resetSubmitLoadingState(bookingForm);

    if (bookingForm.dataset.submitLoadingStateInitialised === "true") {
      return;
    }

    bookingForm.dataset.submitLoadingStateInitialised = "true";

    bookingForm.addEventListener("submit", () => {
      const submitButton = findSubmitButton(bookingForm);

      if (!submitButton) {
        return;
      }

      submitButton.disabled = true;
      submitButton.setAttribute("aria-busy", "true");

      // Icon-only buttons have no room for text, so they swap their icon for the spinner they carry instead.
      const loadingIndicator = submitButton.querySelector<Element>(
        "[data-submit-loading-indicator]"
      );

      if (loadingIndicator) {
        submitButton
          .querySelectorAll<Element>("[data-submit-idle-indicator]")
          .forEach((idleIndicator) => idleIndicator.classList.add("hidden"));
        loadingIndicator.classList.remove("hidden");
        return;
      }

      submitButton.dataset.idleText = submitButton.textContent ?? "";
      submitButton.textContent = "Searching...";
    });
  });
};

const findSubmitButton = (bookingForm: HTMLFormElement) =>
  bookingForm.querySelector<HTMLButtonElement>("button[type='submit']");

// A page restored from the back/forward cache keeps its loading state, so put the button back the way it looked before submit.
const resetSubmitLoadingState = (bookingForm: HTMLFormElement) => {
  const submitButton = findSubmitButton(bookingForm);

  if (submitButton?.getAttribute("aria-busy") !== "true") {
    return;
  }

  submitButton.disabled = false;
  submitButton.removeAttribute("aria-busy");
  submitButton
    .querySelectorAll<Element>("[data-submit-idle-indicator]")
    .forEach((idleIndicator) => idleIndicator.classList.remove("hidden"));
  submitButton
    .querySelector<Element>("[data-submit-loading-indicator]")
    ?.classList.add("hidden");

  if (submitButton.dataset.idleText !== undefined) {
    submitButton.textContent = submitButton.dataset.idleText;
    delete submitButton.dataset.idleText;
  }
};

document.addEventListener("DOMContentLoaded", initBookingForm);

document.addEventListener("turbo:load", initBookingForm);

window.addEventListener("pageshow", initBookingForm);
